import { j as e } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as i } from "react";
import { I as l } from "../../../../IconBase-CxZyIWw2.js";
const s = i((o, t) => /* @__PURE__ */ e.jsx(
  l,
  {
    ref: t,
    ...o,
    image: (r) => /* @__PURE__ */ e.jsx(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16",
        ...r,
        children: /* @__PURE__ */ e.jsx(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M5.032 15.004c6.037 0 9.34-5.003 9.34-9.34q0-.213-.01-.425A6.7 6.7 0 0 0 16 3.54a6.6 6.6 0 0 1-1.885.518 3.3 3.3 0 0 0 1.443-1.816 6.6 6.6 0 0 1-2.084.796 3.284 3.284 0 0 0-5.595 2.994 9.32 9.32 0 0 1-6.765-3.43 3.282 3.282 0 0 0 1.015 4.382 3.3 3.3 0 0 1-1.485-.41l-.001.041a3.284 3.284 0 0 0 2.633 3.22 3.3 3.3 0 0 1-1.483.055 3.29 3.29 0 0 0 3.067 2.28A6.6 6.6 0 0 1 0 13.53a9.3 9.3 0 0 0 5.032 1.475",
            clipRule: "evenodd"
          }
        )
      }
    )
  }
));
s.displayName = "TwitterIcon";
export {
  s as TwitterIcon,
  s as default
};
//# sourceMappingURL=index.js.map
